module.exports = "<div class=\"modal-footer clear\"> <a class=\"btn btn-icon btn-default\" ng-click=cancel()> <i class=\"fa fa-reply\"></i> {{ 'jdro_common.retry' | translate }} </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/buttons/buttonClose.html
// module id = 385
// module chunks = 0